export default "__VITE_ASSET__DLSm8df___"